<header
    #headerAndBannerContainer
    class="header-container"
    [attr.role]="'banner'"
    [ngStyle]="{
        '--header-height-mobile.px': HEADER_MAIN_MOBILE_HEIGHT,
        '--header-height-desktop.px': HEADER_MAIN_DESKTOP_HEIGHT,
        '--header-height-desktop-with-menu.px': HEADER_DESKTOP_HEIGHT_WITH_MENU,
    }">
    <div #bannerContainer>
        <ngx-loading-bar [color]="'#444444'" [height]="'5px'" [includeSpinner]="false" [fixed]="true"></ngx-loading-bar>
        <h-banners-top-container></h-banners-top-container>

        @if ((isUnderMenuBreakpoint$ | async) === true && !isInServerMode) {
            @if (menuFacade.links$ | async; as seoLinks) {
                <h-seo-links [seoLinks]="seoLinks"></h-seo-links>
            }
        }

        <section
            #headerLinksContainer
            class="header-links-container"
            [class.transparent]="(isHeaderTransparent$ | async) === true">
            <h-header-links></h-header-links>
        </section>
    </div>
    <!-- Background equal to scrolling part (fixed) -- needed to have a smooth scrolling when header goes from relative to fixed-->
    <div
        #headerBackgroundFixed
        class="header-background-fixed"
        [hidden]="headerState().headerPosition !== 'fixed'"></div>
    <!-- Header : scrolling part -->
    <div
        #headerMainContainer
        class="header-main-container"
        [class.fixed]="headerState().headerPosition === 'fixed'"
        [class.transparent]="
            (isHeaderTransparent$ | async) === true &&
            shouldBeTransparent() &&
            (isHeaderFullTransparentFF$ | async) === false
        "
        [class.full-transparent]="
            (isHeaderTransparent$ | async) === true &&
            shouldBeTransparent() &&
            (isHeaderFullTransparentFF$ | async) === true
        "
        [class.hide-header-bar]="headerState().isOnlyMenuBarDisplayed"
        [class.menu-open]="isSubMenuActive()"
        [class.background-white]="isSubMenuActive()">
        <div #headerMain class="header-main">
            <h-header-bar
                class="header-bar"
                [isUnderMenuBreakpoint]="!isInServerMode && (isUnderMenuBreakpoint$ | async) === true"></h-header-bar>
        </div>
        <div #menuBar class="header-menu-bar">
            @if (isInServerMode || (isUnderMenuBreakpoint$ | async) === false) {
                <h-menu-bar></h-menu-bar>
            }
        </div>
    </div>
    @if (isAccountCreated) {
        <h-account-creation-banner
            [isAccountCreatedByWeChat]="isAccountCreatedByWechat"
            (closeBanner)="closeAccountCreationBanner()">
        </h-account-creation-banner>
    }
</header>
